import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SocketService } from '../../../../../../services/socket.service';

@Component({
  selector: 'app-modal-more-info',
  standalone: true,
  imports: [MatButtonModule, CommonModule, TranslateModule],
  templateUrl: './modal-more-info.component.html',
  styleUrl: './modal-more-info.component.scss',
  encapsulation: ViewEncapsulation.None,

})
export class ModalMoreInfoComponent {

  constructor(
    public dialogRef: MatDialogRef<ModalMoreInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private socketService: SocketService
  ) {}

  content_more_information: string = '';

  ngOnInit() {

    this.socketService.emitModalMoreInfo(this.data);



    this.socketService.onModalMoreInfo((data: any) => {
      this.content_more_information = data.report;
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  static open(dialog: MatDialog, data: any) {
    return dialog.open(ModalMoreInfoComponent, {
      width: '800px',
      height: '80%',
      data: data,
    });
  }

}
